"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    DropdownItem = require("./DropdownItem.js"),
    DownIcon = require("../icons/DownIcon.js"),
    closeOnClick = require("../wrappers/closeOnClick.js"),
    keyControlledMenu = require("../wrappers/keyControlledMenu.js"),
    DropdownMenu = function DropdownMenu(s) {
  var e = s.text,
      o = classnames("blx-dropdown-trigger", {
    "blx-active": s.isOpen,
    "blx-disabled": s.disabled,
    "blx-invalid": !s.isValid
  });
  if (s.value) for (var l = 0; l < s.options.length; l++) {
    var r = s.options[l];

    if (r.value === s.value) {
      e = r.text || r.triggerContent || r.element;
      break;
    }
  }
  return React.createElement("div", {
    style: s.style,
    className: classnames("blx-dropdown-wrapper", s.className),
    ref: s.forwardedRef
  }, React.createElement("div", {
    className: "blx-dropdown"
  }, s.label && React.createElement("label", {
    className: "blx-ui-text " + (s.disabled ? "blx-disabled" : "")
  }, s.label), React.createElement("button", {
    className: o,
    disabled: s.disabled,
    onClick: s.toggle,
    title: e,
    autoFocus: s.autoFocus,
    onKeyDown: s.onKeyDown,
    onFocus: s.onTriggerFocus
  }, s.icon, React.createElement("span", {
    className: s.value ? "blx-dropdown-text" : "blx-dropdown-placeholder"
  }, e), React.createElement(DownIcon, {
    className: "blx-dropdown-arrow"
  })), React.createElement("div", {
    className: classnames("blx-dropdown-menu", {
      "blx-hidden": !s.isOpen
    })
  }, React.createElement("ul", {
    className: classnames("blx-dropdown-list", {
      "blx-scrollable": s.scrollable
    })
  }, s.options.map(function (e, o) {
    return React.createElement(DropdownItem, {
      key: e.text || e.key,
      option: e,
      ref: s.optionsRefs[o],
      selected: s.value === e.value,
      onKeyDown: s.onKeyDown,
      onKeyUp: s.onKeyUp,
      onSelect: s.onSelect
    });
  })))), !s.isValid && React.createElement("span", {
    className: "blx-invalid-input-message"
  }, s.invalidErrorMessage));
};

DropdownMenu.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isOpen: PropTypes.bool,
  scrollable: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  text: PropTypes.string,
  icon: PropTypes.node,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    triggerContent: PropTypes.string,
    href: PropTypes.string,
    element: PropTypes.node,
    key: PropTypes.string
  })),
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  autoFocus: PropTypes.bool,
  isValid: PropTypes.bool,
  invalidErrorMessage: PropTypes.string
}, DropdownMenu.defaultProps = {
  className: "",
  style: null,
  isOpen: !1,
  scrollable: !1,
  options: [],
  text: "Choose an option",
  icon: null,
  label: "",
  value: null,
  triggerContent: null,
  onSelect: function onSelect() {},
  autoFocus: !1,
  isValid: !0,
  invalidErrorMessage: null
}, module.exports = closeOnClick(keyControlledMenu(DropdownMenu));